import {Link} from "react-router-dom";
import LOGO from './../../img/LOGO.png'
import LocaleSwitch from "../LocaleSwitch";
import React, {useContext, useState} from "react";
import {LanguageContext} from "../../App";
import {isMobile} from "react-device-detect";

const Header = () => {
    const {language} = useContext(LanguageContext)

    const [isMobileMenu, setIsMobileMenu] = useState(false)

    const mmenuShow = () => {
        console.log('mclick')
        setIsMobileMenu(true)
    }
    const mmenuHide = () => {
        setIsMobileMenu(false)
    }

    return (
        <header className='bg-neutral-800'>

            {isMobileMenu &&
                <>
                    <div className='fixed top-0 z-50 left-0 bg-black/90 z-50 w-full h-screen '>
                        <div className='w-full h-full flex flex-col justify-center'>
                            <div className='m-auto text-white text-center'>

                                <div className='pb-10'>Мариуполь 5000</div>
                                <div className='w-20 mb-4 m-auto text-black'>
                                    <LocaleSwitch/>
                                </div>

                                <Link to="/join">
                                    <button
                                        className='mx-4 py-2 px-3  text-sm text-gray-100 bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 to-red-700 rounded-sm'>
                                        {language.header.join_button}
                                    </button>
                                </Link>
                                <a target='_blank' href="https://t.me/remap_ru">
                                    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                                         width="26" height="26"
                                         viewBox="0 0 48 48"
                                         className='m-auto mt-4'
                                    >
                                        <path fill="#29b6f6" d="M24 4A20 20 0 1 0 24 44A20 20 0 1 0 24 4Z">
                                        </path>
                                        <path fill="#fff"
                                              d="M33.95,15l-3.746,19.126c0,0-0.161,0.874-1.245,0.874c-0.576,0-0.873-0.274-0.873-0.274l-8.114-6.733 l-3.97-2.001l-5.095-1.355c0,0-0.907-0.262-0.907-1.012c0-0.625,0.933-0.923,0.933-0.923l21.316-8.468 c-0.001-0.001,0.651-0.235,1.126-0.234C33.667,14,34,14.125,34,14.5C34,14.75,33.95,15,33.95,15z">
                                        </path>
                                        <path fill="#b0bec5"
                                              d="M23,30.505l-3.426,3.374c0,0-0.149,0.115-0.348,0.12c-0.069,0.002-0.143-0.009-0.219-0.043 l0.964-5.965L23,30.505z">
                                        </path>
                                        <path fill="#cfd8dc "
                                              d="M29.897,18.196c-0.169-0.22-0.481-0.26-0.701-0.093L16,26c0,0,2.106,5.892,2.427,6.912 c0.322,1.021,0.58,1.045,0.58,1.045l0.964-5.965l9.832-9.096C30.023,18.729,30.064,18.416,29.897,18.196z">
                                        </path>
                                    </svg>
                                </a>
                                <div className='pt-10'>
                                    <svg onClick={mmenuHide} xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 m-auto" fill="none"
                                         viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12"/>
                                    </svg>
                                </div>

                            </div>

                        </div>
                    </div>
                </>


            }


            <div className='flex h-16 w-full justify-between'>
                <div className='flex items-center '>
                    <img className='mb-1 ml-4' src={LOGO} alt="reMap - Хроника протестов в Росссии"
                         style={{width: '120px', height: '35px'}}
                    />
                    {
                        !isMobile &&
                            <h1 className='p-3 ml-2 text-base text-gray-400'>
                                Мариуполь 5000
                                <span className="ml-2 absolute inline-flex rounded-full h-3 w-3 bg-red-500">
                                <span className="relative inline-flex rounded-full h-3 w-3 bg-red-500 animate-ping">
                                </span>
                            </span>
                            </h1>
                    }

                </div>
                {
                    isMobile ?
                        <button onClick={mmenuShow}>
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 m-4" fill="none" viewBox="0 0 24 24"
                                 stroke="currentColor" strokeWidth="2">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h8m-8 6h16"/>
                            </svg>
                        </button>
                        :
                        <div className='flex items-center '>
                            <LocaleSwitch/>
                            <a target='_blank' rel="noreferrer" href="https://t.me/remap_ru">
                                <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                                     width="26" height="26"
                                     viewBox="0 0 48 48"
                                     className=''
                                >
                                    <path fill="#29b6f6" d="M24 4A20 20 0 1 0 24 44A20 20 0 1 0 24 4Z">
                                    </path>
                                    <path fill="#fff"
                                          d="M33.95,15l-3.746,19.126c0,0-0.161,0.874-1.245,0.874c-0.576,0-0.873-0.274-0.873-0.274l-8.114-6.733 l-3.97-2.001l-5.095-1.355c0,0-0.907-0.262-0.907-1.012c0-0.625,0.933-0.923,0.933-0.923l21.316-8.468 c-0.001-0.001,0.651-0.235,1.126-0.234C33.667,14,34,14.125,34,14.5C34,14.75,33.95,15,33.95,15z">
                                    </path>
                                    <path fill="#b0bec5"
                                          d="M23,30.505l-3.426,3.374c0,0-0.149,0.115-0.348,0.12c-0.069,0.002-0.143-0.009-0.219-0.043 l0.964-5.965L23,30.505z">
                                    </path>
                                    <path fill="#cfd8dc "
                                          d="M29.897,18.196c-0.169-0.22-0.481-0.26-0.701-0.093L16,26c0,0,2.106,5.892,2.427,6.912 c0.322,1.021,0.58,1.045,0.58,1.045l0.964-5.965l9.832-9.096C30.023,18.729,30.064,18.416,29.897,18.196z">
                                    </path>
                                </svg>
                            </a>
                            <Link to="/join">
                                <button
                                    className='mx-4 py-2 px-3  text-sm text-gray-100 bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 to-red-700 rounded-sm'>
                                    {language.header.join_button}
                                </button>
                            </Link>
                        </div>

                }



            </div>
        </header>
    )
}

export default Header